export default "__VITE_ASSET__C0c606RJ__"